<template>
  <page :load="init">
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div></div>
            <v-spacer></v-spacer>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          </v-card-title>
          <!-- <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :footer-props="{'items-per-page-options': itemsPerPage }" v-bind:options.sync="pagination" item-key="ipAddress" :loading="loading" :no-data-text="noDataText" :custom-filter="customSearch" v-model="selected" select-all>
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span v-on="on">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item="row">
              <td style="width:50px">
                <v-checkbox primary hide-details v-model="row.selected"></v-checkbox>
              </td>
              <td>{{ row.item.ipAddress }}</td>
              <td>{{ formatDisplayDateTime(row.item.createdDate) }}</td>
            </template>
          </v-data-table> -->
          <v-data-table
            :custom-filter="customSearch"
            :headers="headers"
            :items="items"
            :loading="loading"
            :no-data-text="noDataText"
            :search="search"
            item-key="ipAddress"
            v-model="selected"
            show-select
          >
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doShowAdd" :loading="loading">
            Add IP Address
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-btn class="mx-2" color="error" @click="doPromptRemove" :loading="loading">
            Remove Selected
            <v-icon right>mdi-minus-circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <transition name="slide-x-transition" mode="out-in">
        <v-flex xs12 v-if="showAddPnl">
          <v-card class="mt-4">
            <v-card-title>
              <div class="headline">New Whitelist IP Address</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="newIpAddress"
                label="IP Address*"
                :error-messages="errors.collect('ipAddress')"
                data-vv-name="ipAddress"
                data-vv-as="IP Address"
                v-validate="'required|max:20'"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="doValidateAdd"> Confirm </v-btn>
              <v-btn color="error" @click="showAddPnl = false"> Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </transition>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure you want to remove selected record(s)? </confirm>
    </v-layout>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: 'IP Address', align: 'left', value: 'ipAddress' },
        { text: 'Created Date', align: 'left', value: 'createdDate' }
      ],
      promptRemove: false,
      showAddPnl: false,
      menu: {},
      newIpAddress: null
    }
  },
  methods: {
    async init() {
      this.loading = true
      const apiUrl = this.$store.state.adminUser.security.menu.whitelist
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((whitelist) => {
              const convertWhitelist = {
                ipAddress: whitelist.ipAddress,
                createdDate: whitelist.createdDate
              }
              this.items.push(convertWhitelist)
            })
            // Extract the menu
            this.menu = extractMenu(result.data._links)
          } else {
            this.items = []
          }
          this.loading = false
        } catch (error) {
          throw error
        }
      } else {
        throw new Error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    doPromptRemove() {
      if (this.selected.length > 0) {
        this.promptRemove = true
      } else {
        this.warnMessage('Please select record(s) to be removed.')
      }
    },
    doShowAdd() {
      this.newIpAddress = null
      this.showAddPnl = true
    },
    async doRemove() {
      const apiURI = this.menu.remove
      if (apiURI) {
        this.loading = true
        let postForm = []
        this.selected.map((select) => {
          postForm.push(select.ipAddress)
        })
        try {
          const result = await this.$http.post(apiURI, postForm)
          this.message(result.data)

          // Reinit
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    doValidateAdd() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doAdd()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doAdd() {
      const apiURI = this.menu.add
      if (apiURI) {
        this.loading = true
        this.showAddPnl = false
        let postForm = []
        postForm.push(this.newIpAddress)
        try {
          const result = await this.$http.post(apiURI, postForm)
          this.message(result.data)

          // Reinit
          this.init()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
